import React from "react";
import AboutIcon from "assets/images/components/AboutIcon";
import ContentBox from "components/ContentBox";
import TitleSection from "components/TitleSection";
import { useTranslation } from "react-i18next";
import "./styles.scss"

const About = () => {
  const { t } = useTranslation();
  return (
    <ContentBox>
      <TitleSection title={t("about.title")} Icon={AboutIcon} />
      <h3>{t("about.header-location")}</h3>
      <section className="about flex-row w-100">
        <div className="content-box content-box--medium">
          <h3 className="nl_flag">The Netherlands</h3>
          <h4>HEADQUARTERS</h4>
          <p>
            Wijkersloot 5A | 3961 MN
            <br />
            Utrecht | The Netherlands
            <br />
            info@red-to-blue.com
          </p>
        </div>
        <div className="content-box content-box--medium">
          <h3 className="ro_flag">Romania</h3>
          <h4>IT SOLUTIONS CENTER</h4>
          <p>
            No. 53B | Alexandru Vaida Voevod Street @Regus Office
            <br />
            Cluj-Napoca | Romania
            <br />
            0745 887 056 | info@red-to-blue.com
          </p>
        </div>
      </section>
    </ContentBox>
  );
};

export default About;
